import { useEffect, useState } from "react";
import { Button } from "../../../../core/components/Button";
import { Row } from "../../../../core/components/Row";
import { RenderInput } from "../../../home/presentation/components/RenderInput";
import { ArrowRightIcon } from "../../../../core/icons/ArrowRight";
import { Column } from "../../../../core/components/Column";
import { TrashIcon } from "../../../../core/icons/Trash";

export const ConfigLottery: React.FC<{
	next: () => void;
	valueInputParticipant: string;
	valueInputPrize: string;
	listParticipant: string[];
	listPrizes: string[];
	setListParticipant: React.Dispatch<React.SetStateAction<string[]>>;
	setListPrizes: React.Dispatch<React.SetStateAction<string[]>>;
	setValueInputParticipant: React.Dispatch<React.SetStateAction<string>>;
	setValueInputPrize: React.Dispatch<React.SetStateAction<string>>;
	handleInputChange: (e: React.ChangeEvent<HTMLInputElement>, type: "participant" | "prize" | "title" | "date" | "hour") => void;
	handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement>, type: "participant" | "prize" | "title" | "date" | "hour") => void;
}> = ({
	next,
	valueInputParticipant,
	valueInputPrize,
	listParticipant,
	listPrizes,
	setListParticipant,
	setListPrizes,
	handleInputChange,
	handleKeyDown,
	setValueInputParticipant,
	setValueInputPrize,
}) => {
	const [inputError, setInputError] = useState({
		participant: false,
		prize: false,
	});

	const handleClear = () => {
		setListParticipant([]);
		setListPrizes([]);
		setValueInputParticipant("");
		setValueInputPrize("");
		setInputError({
			participant: false,
			prize: false,
		});
	};
	useEffect(() => {
		if (listPrizes.length > 0) setInputError((prev) => ({ ...prev, prize: false }));
		if (listParticipant.length > 0) setInputError((prev) => ({ ...prev, participant: false }));
	}, [listPrizes, listParticipant]);

	const handleNext = () => {
		const countPrizes = listPrizes.length;
		const countParticipant = listParticipant.length;
		if (countPrizes === 0 || countParticipant === 0) {
			setInputError({
				prize: countPrizes === 0,
				participant: countParticipant === 0,
			});
			return;
		}
		next();
	};

	return (
		<>
			<RenderInput
				id="participant"
				label="Escribe el nombre del participante"
				valueInput={valueInputParticipant}
				onChange={(e) => handleInputChange(e, "participant")}
				onKeyDown={(e) => handleKeyDown(e, "participant")}
				list={listParticipant}
				setList={setListParticipant}
				error={inputError.participant}
			/>
			<RenderInput
				id="prize"
				label="¿Qué premios deseas sortear?"
				valueInput={valueInputPrize}
				onChange={(e) => handleInputChange(e, "prize")}
				onKeyDown={(e) => handleKeyDown(e, "prize")}
				list={listPrizes}
				setList={setListPrizes}
				error={inputError.prize}
			/>
			<Column className="w-full gap-2">
				<Button
					className="font-bold max-md:order-last"
					color="yellow"
					onClick={handleClear}
				>
					<Row
						className="gap-1"
						crossAxisAlignment="center"
						mainAxisAlignment="center"
					>
						<TrashIcon className="w-5 h-5" />
						<span>Limpiar</span>
					</Row>
				</Button>
				<Row
					className="gap-2 font-bold"
					flexible
					responsiveCol
				>
					<Button
						className="md:w-1/2"
						color="yellow"
						isDisabled={true}
					>
						<Row
							className="gap-1"
							crossAxisAlignment="center"
							mainAxisAlignment="center"
						>
							<ArrowRightIcon className="w-5 h-5 rotate-180" />
							<span>Atrás</span>
						</Row>
					</Button>
					<Button
						className="md:w-1/2 max-md:order-first"
						onClick={handleNext}
						color="orange"
						secondary
					>
						<Row
							className="gap-1"
							crossAxisAlignment="center"
							mainAxisAlignment="center"
						>
							<span>Siguiente</span>
							<ArrowRightIcon className="w-5 h-5" />
						</Row>
					</Button>
				</Row>
			</Column>
		</>
	);
};
